export default {
  allRecipes: [],
}
